import React, { useEffect } from "react";
import { useRoutes } from 'react-router-dom';

import Home from '@/pages/Home';
import FormView from '@/pages/FormView';
import FormEdit from '@/pages/FormEdit';
import UserAuth from '@/pages/UserAuth';
import Msg from '@/pages/Msg';
import MsgAdd from '@/pages/MsgAdd';
import AlbumClass from '@/pages/AlbumClass';
import AlbumUpload from '@/pages/AlbumUpload';
import Posts from '@/pages/Posts';
import PostsAdd from '@/pages/PostsAdd';
import My from '@/pages/My';
import Seting from '@/pages/Seting';
import Medias from '@/pages/Medias';
import ShoppingCart from '@/pages/ShoppingCart';
import MyPosts from '@/pages/MyPosts';
import MyPostsInfo from '@/pages/MyPostsInfo';
import DriftingDown from '@/pages/DriftingDown';
import Index from '@/pages/Index';
import GiftList from '@/pages/GiftList';
import AlbumInfo from '@/pages/AlbumInfo';
import AlbumEdit from '@/pages/AlbumEdit';
import VideoAdd from '@/pages/VideoAdd';
import Videos from '@/pages/Videos';
import VideoInfo from '@/pages/VideoInfo';
import Space from '@/pages/Space';
import Planet from '@/pages/Planet';
import UserEdit from '@/pages/UserEdit';
import PostsSeting from '@/pages/PostsSeting';
import PlanetUser from '@/pages/PlanetUser';
import AsyncInfo from '@/pages/AsyncInfo';
import FamilyRegistry from '@/pages/FamilyRegistry';
import AIChat from '@/pages/AIChat';

import { environment } from './service/baseUrl';
import {
  GetUserDtoByCode,GetWXUserByOpenId
} from './service/service';
import {
  Toast,Modal
} from 'antd-mobile-v5';
import { ExclamationCircleFill } from 'antd-mobile-icons';


var route = [
  { path: '/home', element: <Home /> },
  { path: '/formView', element: <FormView /> },
  { path: '/formEdit', element: <FormEdit /> },
  { path: '/userAuth', element: <UserAuth /> },
  { path: '/msg', element: <Msg /> },
  { path: '/msgAdd', element: <MsgAdd /> },
  { path: '/albumClass', element: <AlbumClass /> },
  { path: '/albumUpload', element: <AlbumUpload /> },
  { path: '/posts', element: <Posts /> },
  { path: '/postsAdd', element: <PostsAdd /> },
  { path: '/my', element: <My /> },
  { path: '/seting', element: <Seting /> },
  { path: '/medias', element: <Medias /> },
  { path: '/shoppingCart', element: <ShoppingCart /> },
  { path: '/myPosts', element: <MyPosts /> },
  { path: '/myPostsInfo', element: <MyPostsInfo /> },
  { path: '/driftingDown', element: <DriftingDown /> },
  { path: '/index', element: <Index /> },
  { path: '/giftList', element: <GiftList /> },
  { path: '/albumInfo', element: <AlbumInfo /> },
  { path: '/albumEdit', element: <AlbumEdit /> },
  { path: '/videoAdd', element: <VideoAdd /> },
  { path: '/videos', element: <Videos /> },
  { path: '/videoInfo', element: <VideoInfo /> },
  { path: '/space', element: <Space /> },
  { path: '/planet', element: <Planet /> },
  { path: '/userEdit', element: <UserEdit /> },
  { path: '/postsSeting', element: <PostsSeting /> },
  { path: '/planetUser', element: <PlanetUser /> },
  { path: '/asyncInfo', element: <AsyncInfo /> },
  { path: '/familyRegistry', element: <FamilyRegistry /> },
  { path: '/aiChat', element: <AIChat /> },
  { path: '*', element: <Index /> },
];

function App() {

  useEffect(() => {
    var openid = localStorage.getItem("openid");

    var url = window.location.search; //获取url中"?"符后的字串
    var theRequest = new Object();
    if (url.indexOf("?") != -1) {
      var str = url.substr(1);
      var strs = str.split("&");
      for (var i = 0; i < strs.length; i++) {
        theRequest[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1]);
      }
    }

    if (openid == null || openid == "" || openid == undefined) {
      var path = window.location.pathname;
      if (path.includes('/home')) {
        return;
      }

      if (theRequest.code == undefined) {
        window.location.href = environment.wxredirecturi;
        return;
      }
      GetUserDtoByCode(theRequest.code).then(res => {
        if (res.success) {
          if (res.result.item1) {
            if (res.result.item2.headImg != null && res.result.item2.headImg != "") {
              if (res.result.item2.headImg.indexOf("https://") > -1) {
                var urls = res.result.item2.headImg.split("https://").filter(Boolean);
                res.result.item2.headImg = urls.length > 0 ? `https://${urls[urls.length - 1]}` : "";
              } else {
                res.result.item2.headImg = environment.apiEndpoint + "/NNFiles/Img/" + res.result.item2.headImg;
              }
            
            }

            if (res.result.item2.blacklist) {
              showModal();
            }

            localStorage.setItem("user", JSON.stringify(res.result.item2))
            localStorage.setItem("openid", res.result.item2.openId)

            window.location.reload();
          } else {
            Toast.info("内部错误！", 1);
          }
        } else {
          Toast.info("内部错误！", 1);
        }
      });
    } else {

      if (theRequest.state != null && theRequest.state != undefined) {
        
      }

      var state = true;
      var closeFollow = localStorage.getItem("closeFollow");
      if (closeFollow != undefined) {
          closeFollow = new Date(closeFollow);
          closeFollow.setMinutes(closeFollow.getMinutes() + 5);
          if (new Date() < closeFollow) {
              state = false;
          } else {
              localStorage.setItem("closeFollow", new Date());
          }
      }
      if (state) {
        GetWXUserByOpenId().then(res => {
          if (res.success) {
            if (res.result.headImg != null && res.result.headImg != "") {
              if (res.result.headImg.indexOf("https://") > -1) {
                var urls = res.result.headImg.split("https://").filter(Boolean);
                res.result.headImg = urls.length > 0 ? `https://${urls[urls.length - 1]}` : "";
              } else {
                res.result.headImg = environment.apiEndpoint + "/NNFiles/Img/" + res.result.headImg;
              }
            }
            localStorage.setItem("user", JSON.stringify(res.result))

            if (res.result.blacklist) {
              showModal();
            }
          }
        })
      }

    }

  });

  function showModal() {
    Modal.clear();
    
    Modal.show({
      content: (
        <div style={{ textAlign: 'center', padding: '24px 16px' }}>
          <ExclamationCircleFill
            style={{ fontSize: 48, color: '#ff4d4f', marginBottom: 12 }}
          />
          <div style={{ fontSize: 18, fontWeight: 500, color: '#333', marginBottom: 8 }}>
            账号限制通知
          </div>
          <div style={{ fontSize: 15, color: '#666', lineHeight: 1.5 }}>
            由于您的账号涉及违规行为，系统已对您进行限制。
            <br />
            如有疑问，请联系管理员！
          </div>
          <div style={{ textAlign: "center", marginTop: "9%", textDecoration: "underline" }}>
            <a href="https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzIzOTA2OTIyMA==#wechat_redirect"
              style={{ color: "#0538ff" }}>
              联系管理员</a>
          </div>
        </div>
      ),
      // 关键修改：调整弹框样式，确保居中 + 合适宽度
      style: {
        width: 'calc(100% - 32px)', // 左右各留 16px 边距，避免贴边
        maxWidth: '400px', // 最大宽度限制（避免在大屏幕上过宽）
        zIndex: 999999999999, // 关键设置
      },
      bodyStyle: {
        borderRadius: '12px',
        margin: '0 auto', // 确保弹框水平居中
      },
      maskStyle: {
        background: 'rgba(0, 0, 0, 0.6)',
        // zIndex: 9999, // 遮罩层稍低于弹框
      },
      closeOnMaskClick: false,
      closeOnAction: false,
      actions: [],
    });
  }

  var ele = useRoutes(route);

  return (

    <div style={{height:"100%",height:"100%"}}>
      {ele}
    </div>

  );
}

export default App;
